exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-card[data-v-4fdd3043] {\n    max-width: 500px;\n    margin-top: 200px;\n}\n.modal-card-foot[data-v-4fdd3043] {\n    padding-bottom: 20px;\n}\n.modal-card-body[data-v-4fdd3043] {\n    word-break: break-word;\n}\n", ""]);

// exports
